import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import AboutGallerySection from "./components/AboutGallerySection";
import PricingSection from "./components/PricingSection";
import ExperienceSection from "./components/ExperienceSection";
import AccessSection from "./components/AccessSection";
import ContactForm from "./components/ContactForm";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <h1 className="sr-only">
          Lamborghini Countach 25th Anniversary Model商業施設の集客イベント、展示会、PV、映画撮影、
プロポーションなどに。
        </h1>
        <Hero />
        <AboutGallerySection />
        <PricingSection />
        <ExperienceSection />
        <ContactForm />
        <AccessSection />
      </main>
      <Footer />
    </div>
  );
}